module.exports = __webpack_public_path__ + "static/media/accessory3.f7ffeca8.webp";